import { useDictParseList } from '@/utils/useUtils'
import { invoiceTypeList } from '../purchaseRecordList/config'


const getConfigData = (model) => {
  return [
    {
      el: 'select',
      itemConfig: {
        label: '企业主体全称',
        prop: 'orgId',
      },
      elConfig: {
        options: {
          label: 'orgName',
          value: 'orgId',
          list: [],
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '统一社会信用代码证号',
        prop: 'orgIdCardNum',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '购买份额数',
        prop: 'purchaseQuantity',
      },
      elConfig: {
        placeholder: '请填写',
      },
      directives: [{ name: 'number', arg: 'integer', value: 4 }],
    },
    {
      el: 'text',
      itemConfig: {
        label: '付款金额(元)',
        prop: 'payAmount',
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '付款凭证',
        prop: 'purchaseAttachment',
      },
      elConfig: {
        render: 'UploadCommon',
        showDelBtn: true,
        limit: 5,
        sizeType: 2, // 单文件最大10M
        listType: 'text',
        acceptType: '.jpg,.png,.jpeg,.pdf',
        fileList: model.value.purchaseAttachment,
        commonUpload: true,
        group: 'finance',
        code: 'finance_payment_voucher',
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '开票类型',
        prop: 'invoiceType',
      },
      elConfig: {
        options: {
          label: 'label',
          value: 'value',
          list: useDictParseList(invoiceTypeList),
        },
      },
    },
  ]
}

const rules = {
  orgId: [
    { required: true, message: '请选择企业主体全称', trigger: 'change' },
  ],
  purchaseQuantity: [
    { required: true,
      trigger: 'change',
      validator: (_, val, callback) => {
        if (val === '') {
          return callback(new Error('购买份数不能为空'))
        }
        if (Number(val) < 1) {
          return callback(new Error('购买份数不能小于1'))
        }
        if (Number(val) > 9999) {
          return callback(new Error('购买份数不能大于9999'))
        }
        return callback()
      },
    },
  ],
  purchaseAttachment: [
    { required: true, message: '请上传付款凭证', trigger: 'change' },
  ],
  invoiceType: [
    { required: true, message: '请选择开票类型', trigger: 'change' },
  ],
}

export { getConfigData, rules }
